import { render, staticRenderFns } from "./SequenceFolder.vue?vue&type=template&id=fac2da40&scoped=true"
import script from "./SequenceFolder.vue?vue&type=script&lang=js"
export * from "./SequenceFolder.vue?vue&type=script&lang=js"
import style0 from "./SequenceFolder.vue?vue&type=style&index=0&id=fac2da40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac2da40",
  null
  
)

export default component.exports